import Image, { ImageProps } from 'next/image';
import { cloudflareLoader } from '~/shared/components/Image/loaders/cloudflareLoader';
import { defaultLoader } from '~/shared/components/Image/loaders/defaultLoader';
import { useConfig } from '~/shared/hooks';

const ImageComponent = (props: ImageProps) => {
    const {
        config: { NEXT_PUBLIC_CLOUDFLARE_LOADER_URL },
    } = useConfig();

    function getLoader() {
        const isStatic = !/^https?:\/\//.test(props.src.toString());
        const isSvg = props.src.toString().includes('.svg');
        if (isStatic) {
            return undefined;
        }
        if (isSvg) {
            return defaultLoader;
        }
        if (NEXT_PUBLIC_CLOUDFLARE_LOADER_URL) {
            return cloudflareLoader;
        }
        return defaultLoader;
    }

    const loader = getLoader();

    return <Image {...props} loader={loader} />;
};

export default ImageComponent;
